import { extractCoreLabels } from 'src/apps/dashboard/helpers/ConfigurationProcessingHelpers';
import { UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const useBusinessUnitLabelDisplayName = (): string => {
	const { configuration } = useConfiguration();

	if (!configuration?.PLATFORM) {
		return '';
	}

	const coreLabels = extractCoreLabels(configuration.PLATFORM);
	const unitIdLabel = coreLabels.find((label) => label.label === UNIT_ID_LABEL_KEY);

	return unitIdLabel?.displayName ?? '';
};
